import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ColumnModel } from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { PIMeasurementToolModel } from '../../models/pi-measurement-tool.model';

@Component({
    selector: 'pace-pi-measurement-tools-expandable',
    templateUrl: './pi-measurement-tool-expandable.component.html',
    standalone: false,
})
export class PiMeasurementToolExpandableComponent implements OnInit {
    @Input() public parentForm: FormArray;
    @Input() public row: PIMeasurementToolModel;
    @Input() public columns: ColumnModel[];

    @Output() public deleteRow = new EventEmitter();
    @Output() public updateRow = new EventEmitter<AbstractControl>();

    protected readonly faChevronDown = faChevronDown;
    protected readonly faChevronUp = faChevronUp;
    protected readonly faTrashAlt = faTrashAlt;
    public isCollapsed = false;
    public formChildren: FormArray;
    public pIMeasurementToolExpandableForm: FormGroup;

    public constructor(private formBuilder: FormBuilder) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.pIMeasurementToolExpandableForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.parentForm.push(this.pIMeasurementToolExpandableForm);
    }

    public deleteMeasurementToolRow(): void {
        this.deleteRow.emit();
    }

    public updateRowValidation(): void {
        this.updateRow.emit(this.pIMeasurementToolExpandableForm);
    }

    public get(field: string): string {
        return _.get(this.row, field);
    }
}
